import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { setEnv } from './env'


import {Provider} from 'react-redux'
import store from './redux/store'
setEnv();
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js